import {
  ADD_TO_HISTORY,
  SET_CURRENT_URL,
  CLEAR_HISTORY
} from './actions'

const appendHistory = function (state, url) {
  if (url.name) {
    let current = state.history
    if (current) {
      let next = {
        previous: current,
        url
      }
      current.next = next
      state.history = next
    } else {
      state.history = { url }
    }
  }
}

const mutations = {
  [ADD_TO_HISTORY]: (state, url) => {
    if (url.name) {
      appendHistory(state, url)
    }
  },
  [SET_CURRENT_URL]: (state, url) => {
    state.current = url
  },
  [CLEAR_HISTORY]: (state, inter) => {
    state.history = null
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/router/store/mutations.js